export const editMember = {
    state: {
        memberToEdit: null,
        fillUserRolePermissions: false
    },

    getters: {
        memberToEdit(state) {
            return state.memberToEdit;
        },

        fillUserRolePermissions(state) {
            return state.fillUserRolePermissions;
        }
    },

    mutations: {
        setMemberToEdit(state, data) {
            state.memberToEdit = data;
        },

        setFillUserRolePermissions(state, data) {
            state.fillUserRolePermissions = data;
        }
    },

    actions: {
        getPermissions(context, payload) {
            return context.dispatch('get', {
                url: api + 'permissions',
                params: {
                    club_id: payload.clubId
                }
            });
        },

        getRoles(context) {
            return context.dispatch('get', {
                url: api + 'roles'
            });
        },

        getRolePermissions(context, payload) {
            return context.dispatch('get', {
                url: api + 'roles/' + payload.roleId + '/permissions',
                params: {
                    club_id: payload.clubId
                }
            });
        },

        editMember(context, payload) {
            return context.dispatch('post', {
                url: api + 'update-user-role-permissions',
                data: payload
            });
        }
    }
};

export default editMember;
